/**
 * Frequency normalization utilities.
 * Monthly is the base unit for all budget calculations.
 */

export const FREQUENCIES = {
  weekly: 'weekly',
  biweekly: 'biweekly',
  semimonthly: 'semimonthly',
  monthly: 'monthly',
  annual: 'annual',
};

export const FREQUENCY_MULTIPLIERS = {
  weekly: 52 / 12,
  biweekly: 26 / 12,
  semimonthly: 2,
  monthly: 1,
  annual: 1 / 12,
};

export const FREQUENCY_LABELS = {
  es: {
    weekly: 'Semanal',
    biweekly: 'Bisemanal',
    semimonthly: 'Quincenal',
    monthly: 'Mensual',
    annual: 'Anual',
  },
  en: {
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    semimonthly: 'Semi-monthly',
    monthly: 'Monthly',
    annual: 'Annual',
  },
  fr: {
    weekly: 'Hebdomadaire',
    biweekly: 'Aux deux semaines',
    semimonthly: 'Bimensuel',
    monthly: 'Mensuel',
    annual: 'Annuel',
  },
};

export function toMonthly(amount, frequency) {
  const multiplier = FREQUENCY_MULTIPLIERS[frequency];
  if (multiplier == null) return amount;
  return amount * multiplier;
}

export function fromMonthly(monthlyAmount, frequency) {
  const multiplier = FREQUENCY_MULTIPLIERS[frequency];
  if (multiplier == null) return monthlyAmount;
  return monthlyAmount / multiplier;
}
